/**
 * The REST `cause` and message of a call the API refused. `customBaseQuery` puts the cause on
 * `m24Limit`. A network error or a failed S3 part has no API message, so the caller shows its own.
 */
export function masterUploadRefusal(error: unknown): { reason?: unknown; message?: string } {
  const { m24Limit, message, statusCode } = (error ?? {}) as {
    m24Limit?: { reason?: unknown };
    message?: string;
    statusCode?: unknown;
  };
  const fromApi = typeof statusCode === 'number' && typeof message === 'string' && message !== '';
  return { reason: m24Limit?.reason, message: fromApi ? message : undefined };
}
